import { Controller } from "@hotwired/stimulus";
import { hideElements, showElements } from "../utils/misc";

export default class extends Controller {
  static targets = ["section", "backRedirectBtn", "previousSectionBtn", "nextSectionBtn", "finalSectionBtn"];

  static values = {
    currentSection: Number,
  };

  connect() {
    this.resetCurrentSectionValue();
  }

  nextSection() {
    this._sectionFor(this.currentSectionValue).classList.remove("current");
    this.currentSectionValue += 1;
    this._sectionFor(this.currentSectionValue).classList.add("current");

    if (this._withBackRedirectControls()) {
      hideElements([this.backRedirectBtnTarget]);
    }

    if (this._withPaginationControls()) {
      showElements([this.nextSectionBtnTarget, this.previousSectionBtnTarget]);

      if (this.isFinalSection()) {
        this._displayFinalSectionButtons();
      }
    }
  }

  _displayFinalSectionButtons() {
    showElements([this.finalSectionBtnTarget]);
    hideElements([this.nextSectionBtnTarget]);
  }

  previousSection() {
    this._sectionFor(this.currentSectionValue).classList.remove("current");
    this._sectionFor(this.currentSectionValue - 1).classList.add("current");
    this.currentSectionValue -= 1;
    showElements([this.nextSectionBtnTarget, this.previousSectionBtnTarget]);
    hideElements([this.finalSectionBtnTarget]);

    if (this._isFirstSection()) {
      this._displayFirstSectionButtons();
    }
  }

  resetCurrentSectionValue() {
    this.currentSectionValue = 0;
  }

  _displayFirstSectionButtons() {
    hideElements([this.previousSectionBtnTarget]);
    if (this.hasBackRedirectBtnTarget) {
      showElements([this.backRedirectBtnTarget]);
    }
  }

  _sectionFor(sectionNumber) {
    return this.sectionTargets.find((target, index) => index === sectionNumber);
  }

  isFinalSection() {
    return this.currentSectionValue === this.sectionTargets.length - 1;
  }

  _isFirstSection() {
    return this.currentSectionValue === 0;
  }

  _withBackRedirectControls() {
    return this.hasBackRedirectBtnTarget;
  }

  _withPaginationControls() {
    return this.hasPreviousSectionBtnTarget && this.hasNextSectionBtnTarget && this.hasFinalSectionBtnTarget;
  }
}
